import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import { components as plot15Components, extraContent as plot15ExtraContent } from "./components/15-plot";
import { components as room15Components, extraContent as room15ExtraContent } from "./components/15-room";
import { components as plot5Components, extraContent as plot5ExtraContent } from "./components/5-plot";
import { components as room5Components, extraContent as room5ExtraContent } from "./components/5-room";

const principle: Slide = {
  title: "",
  description:
    "In this example you can hear the effect that reverberation has on speech. In this case reverberation has been changed by changing the average absorption of the walls and ceiling (5-15%). The absorption coefficient of the floor surface stays fixed to 5%. The room has the following dimensions: 9x9x18m. The graph shows the difference in clarity between both sound files per octave band.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          items: [
            {
              name: "5% overall",
            },
            {
              name: "15% on walls",
            },
          ],
          options: {},
        },
        {
          type: "button",
          items: [
            {
              name: "Room",
            },
            {
              name: "Plot",
            },
          ],
          options: {},
        },
      ],
      extraContent: [
        [room5ExtraContent, plot5ExtraContent],
        [room15ExtraContent, plot15ExtraContent],
      ],
      components: [
        [room5Components, plot5Components],
        [room15Components, plot15Components],
      ],
    },
  },
};

export default principle;
